import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { useUser } from "../utils/UserContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartSimple} from '@fortawesome/free-solid-svg-icons'
import TradingViewWidget from "../components/TradingViewWidget";
import TradeForm from "../components/TradeForm";
import { useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';

function Trade() {
  const { user } = useUser();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const symbol = queryParams.get("symbol");
  const tradetype = queryParams.get("tradetype");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [type, setType] = useState(tradetype?tradetype:'crypto');
  const [trade, setTrade] = useState(symbol ? symbol : type === "crypto" ? "BTC" : type === "forex" ? "AAPL" : "EUR");
  const [activeTab, setActiveTab] = useState("open")
  const [openTrades, setOpenTrades] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);  
  const [swapTrades, setSwapTrades] = useState([]);
  const [autoTrades, setAutoTrades] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchtrade: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const openTrades = [];
        const closedTrades = [];
        const swapTrades = [];
        data.trades.forEach(trade => {
          if (trade.details === "Running" && trade.action !== "Swap") {
            openTrades.push(trade);
          } else if(trade.action === "Swap") {
            swapTrades.push(trade);
          }else{
            closedTrades.push(trade);
          }
        });
        setOpenTrades(openTrades);
        setClosedTrades(closedTrades);
        setSwapTrades(swapTrades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
    })
  }, [user]);  
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        name: coin.name,
        type: 'crypto',
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price.toFixed(2)),
        amount: 0,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    let total = 0;
    const applyWalletBalance = (list) =>
      list.map(item => {
        const value = item.price;
        total += value;
        return {
          ...item,
          amount: 0
        };
      });
    const merged = [
      ...applyWalletBalance(crypto),
      ...applyWalletBalance(fiat),
      ...applyWalletBalance(stock)
    ];
    const sorted = merged.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock]);

  const CloseTrade = (tradeid) =>{
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_closetrade : true, tradeid: tradeid })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
    })
  } 
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchautotrade: true })
    })
    .then(response => response.json())
    .then(data => {
              console.log(data);
      if (data.status === "success") {
        setAutoTrades(data.trades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
    })
  }, [user]);  
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Trade" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Trade" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-8 col-12">
                <div className="mycard p-2 mt-2">
                  <TradingViewWidget symbol={trade} type={type} />
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <TradeForm trade={trade} setTrade={setTrade} type={type} setType={setType}/>
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '450px'}}>
                  <div className="d-flex align-items-center mb-4">
                    <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Trades</h6>
                    <div className="mytab">
                      <div className={`mytab-item ${activeTab === "open" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("open")}}>Open</div>
                      <div className={`mytab-item ${activeTab === "closed" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("closed")}}>Closed</div>
                      <div className={`mytab-item ${activeTab === "swap" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("swap")}}>Swaps</div>
                      <div className={`mytab-item ${activeTab === "auto" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("auto")}}>Auto</div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {activeTab === "open" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">Date</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {openTrades.length > 0 && openTrades.map((trade, index) => {
                          // PUT THE CODE HERE - inside the map function
                          const baseSymbol = trade.pair.includes('/') 
                          ? trade.pair.split('/')[0] 
                          : trade.pair;
                          const tradeasset = assethistory.find(item => item.symbol === baseSymbol);
                          return (
                            <tr key={index}>
                              <td>{trade.trade_time}</td>
                              <td>
                                {tradeasset ? (
                                  <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
                                ) : (
                                  <span className="me-2" style={{display: 'inline-block', width: 30, height: 30, background: '#333', borderRadius: 6}}></span>
                                )}
                                <span className="fw-bold ms-3">{trade.pair}</span> 
                                <span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>{trade.leverage}X</span> 
                                <span className="ms-2 px-2 py-1 rounded-pill text-warning" style={{backgroundColor: '#ffb70026',fontSize:'12px'}}>{trade.tf}</span>
                              </td>
                              <td>{trade.action}</td>
                              <td>{parseFloat(trade.amount).toFixed(6)} {baseSymbol}</td>
                              <td>${trade.entry}</td>
                              <td
                                className={`fw-bold ${
                                  trade.result === "" 
                                    ? "text-primary" 
                                    : parseFloat(trade.result) > 0 
                                    ? "text-success" 
                                    : parseFloat(trade.result) < 0
                                    ? "text-danger"
                                    : "text-danger"
                                }`}
                              >
                                ${trade.result === "" ? "0.00" : parseFloat(trade.result).toFixed(2)}
                              </td>
                              <td>
                                <div className="myBtn d-inline-block bg-prime" onClick={() => {CloseTrade(trade.trade_id)}}>Close</div>
                              </td>
                            </tr>
                          );
                        })}
                        {openTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Open trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "closed" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">Date</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {closedTrades.length > 0 && closedTrades.map((trade, index) => {
                          const baseSymbol = trade.pair.includes('/') 
                          ? trade.pair.split('/')[0] 
                          : trade.pair;
                          const tradeasset = assethistory.find(item => item.symbol === baseSymbol);
                          return (
                            <tr key={index}>
                               <td>{trade.trade_time}</td>
                              <td>
                                <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
                                <span className="fw-bold ms-3">{trade.pair}</span> 
                                <span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>{trade.leverage}X</span> 
                                <span className="ms-2 px-2 py-1 rounded-pill text-warning" style={{backgroundColor: '#ffb70026',fontSize:'12px'}}>{trade.tf}</span>
                              </td>
                              <td>{trade.action}</td>
                              <td>{parseFloat(trade.amount).toFixed(6)} {baseSymbol}</td>
                              <td>${trade.entry}</td>
                              <td className={`${trade.details === 'Loss' ? 'text-danger' : 'text-success'} fw-bold`}>${trade.result}</td>
                              <td>
                                <div className={`myBtn d-inline-block ${trade.details === 'Loss' ? 'bg-danger' : 'bg-success'}`}>{trade.details}</div>
                              </td>
                            </tr>
                          );
                        })}
                        {closedTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Closed trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "swap" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">Date</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light">Status</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {swapTrades.length > 0 && swapTrades.map((trade, index) => {
                          // PUT THE CODE HERE - inside the map function
                          const baseSymbol = trade.pair.includes('/') 
                          ? trade.pair.split('/')[0] 
                          : trade.pair;
                          const tradeasset = assethistory.find(item => item.symbol === baseSymbol);
                          return (
                            <tr key={index}>
                               <td>{trade.trade_time}</td>
                              <td>
                                <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
                                <span className="fw-bold ms-3">{trade.pair}</span> 
                                <span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>Swap</span> 
                              </td>
                              <td>{trade.action}</td>
                              <td>{parseFloat(trade.amount).toFixed(6)} {baseSymbol}</td>
                              <td>
                                <div className={`myBtn d-inline-block bg-success`}>Success</div>
                              </td>
                            </tr>
                          );
                        })}
                        {swapTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Swap trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "auto" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light">Date</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {autoTrades.length > 0 && autoTrades.map((trade, index) => {
                          // PUT THE CODE HERE - inside the map function
                          const baseSymbol = trade.pair.includes('/') 
                          ? trade.pair.split('/')[0] 
                          : trade.pair;
                          const tradeasset = assethistory.find(item => item.symbol === baseSymbol);
                          return (
                            <tr key={index}>
                              <td>{trade.trade_time}</td>
                              <td>
                                <div>
                                  {tradeasset ? (
                                    <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '25px'}}/>
                                  ) : (
                                    <span style={{display: 'inline-block', width: 30, height: 30, background: '#333', borderRadius: 6}}></span>
                                  )}
                                  <span className="fw-bold ms-2">{trade.pair}</span>
                                  <span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>A</span> 
                                  <span className="ms-2 px-2 py-1 rounded-pill text-warning" style={{backgroundColor: '#ffb70026',fontSize:'12px'}}>{trade.tf}</span>
                                </div>
                                {trade.copydata && (
                                <div className="mt-1 d-flex align-items-center">
                                  <div className="d-flex align-items-center justify-content-center overflow-hidden rounded-circle" style={{width:'20px',height:'20px'}}>
                                    <img src={`/uploads/${trade.copydata.trader_photo}`} alt={trade.copydata.trader_name} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                                  </div>
                                  <span className="fw-semibold ms-1" style={{fontSize:'14px',color:'gray'}}>{trade.copydata.trader_name}</span>
                                </div>
                                )}
                              </td>
                              <td>{trade.action}</td>
                              <td>{parseFloat(trade.amount).toFixed(6)} {baseSymbol}</td>
                              <td>${trade.entry}</td>
                              <td
                                className={`fw-bold ${
                                  trade.result === "" 
                                    ? "text-primary" 
                                    : parseFloat(trade.result) > 0 
                                    ? "text-success" 
                                    : parseFloat(trade.result) < 0
                                    ? "text-danger"
                                    : "text-danger"
                                }`}
                              >
                                ${trade.result === "" ? "0.00" : parseFloat(trade.result).toFixed(2)}
                              </td>
                              <td>
                                {trade.details === "Running" ? (
                                  <div className="myBtn d-inline-block text-prime" style={{ backgroundColor: '#ff6b3520' }}>
                                    Close
                                  </div>
                                ) : trade.details === "Won" ? (
                                  <div className="myBtn d-inline-block bg-success">
                                    Won
                                  </div>
                                ) : trade.details === "Loss" ? (
                                  <div className="myBtn d-inline-block bg-danger">
                                    Loss
                                  </div>
                                ) : (
                                  <div className="myBtn d-inline-block text-prime" style={{ backgroundColor: '#ff6b3520' }}>
                                    Close
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                        {autoTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No auto trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Trade